





import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'loginTitleComp'
})
export default class extends Vue {
  @Prop({type: String, default: ''}) public title!: string;
}
